import ListItem from './ListItem'
import ListItemIcon from './ListItemIcon'
import ListItemText from './ListItemText'

export default Object.assign(ListItem, {
  Text: ListItemText,
  Icon: ListItemIcon,
})
